import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_NAME = "empty_name";
export const ERROR_EMPTY_STATE = "empty_state";
export const ERROR_EMPTY_REGION = "empty_region";

const usStates = [
  { name: "ALABAMA", id: "AL" },
  { name: "ALASKA", id: "AK" },
  { name: "AMERICAN SAMOA", id: "AS" },
  { name: "ARIZONA", id: "AZ" },
  { name: "ARKANSAS", id: "AR" },
  { name: "CALIFORNIA", id: "CA" },
  { name: "COLORADO", id: "CO" },
  { name: "CONNECTICUT", id: "CT" },
  { name: "DELAWARE", id: "DE" },
  { name: "DISTRICT OF COLUMBIA", id: "DC" },
  { name: "FEDERATED STATES OF MICRONESIA", id: "FM" },
  { name: "FLORIDA", id: "FL" },
  { name: "GEORGIA", id: "GA" },
  { name: "GUAM", id: "GU" },
  { name: "HAWAII", id: "HI" },
  { name: "IDAHO", id: "ID" },
  { name: "ILLINOIS", id: "IL" },
  { name: "INDIANA", id: "IN" },
  { name: "IOWA", id: "IA" },
  { name: "KANSAS", id: "KS" },
  { name: "KENTUCKY", id: "KY" },
  { name: "LOUISIANA", id: "LA" },
  { name: "MAINE", id: "ME" },
  { name: "MARSHALL ISLANDS", id: "MH" },
  { name: "MARYLAND", id: "MD" },
  { name: "MASSACHUSETTS", id: "MA" },
  { name: "MICHIGAN", id: "MI" },
  { name: "MINNESOTA", id: "MN" },
  { name: "MISSISSIPPI", id: "MS" },
  { name: "MISSOURI", id: "MO" },
  { name: "MONTANA", id: "MT" },
  { name: "NEBRASKA", id: "NE" },
  { name: "NEVADA", id: "NV" },
  { name: "NEW HAMPSHIRE", id: "NH" },
  { name: "NEW JERSEY", id: "NJ" },
  { name: "NEW MEXICO", id: "NM" },
  { name: "NEW YORK", id: "NY" },
  { name: "NORTH CAROLINA", id: "NC" },
  { name: "NORTH DAKOTA", id: "ND" },
  { name: "NORTHERN MARIANA ISLANDS", id: "MP" },
  { name: "OHIO", id: "OH" },
  { name: "OKLAHOMA", id: "OK" },
  { name: "OREGON", id: "OR" },
  { name: "PALAU", id: "PW" },
  { name: "PENNSYLVANIA", id: "PA" },
  { name: "PUERTO RICO", id: "PR" },
  { name: "RHODE ISLAND", id: "RI" },
  { name: "SOUTH CAROLINA", id: "SC" },
  { name: "SOUTH DAKOTA", id: "SD" },
  { name: "TENNESSEE", id: "TN" },
  { name: "TEXAS", id: "TX" },
  { name: "UTAH", id: "UT" },
  { name: "VERMONT", id: "VT" },
  { name: "VIRGIN ISLANDS", id: "VI" },
  { name: "VIRGINIA", id: "VA" },
  { name: "WASHINGTON", id: "WA" },
  { name: "WEST VIRGINIA", id: "WV" },
  { name: "WISCONSIN", id: "WI" },
  { name: "WYOMING", id: "WY" },
];

export default formWithMessages(props => {
  const { city, regions, onSave, disabled } = props;
  return (
    <Form
      formProps={{
        id: `city-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        name: {
          uiProps: {
            type: "text",
            placeholder: "City name",
            autoFocus: true,
            maxLength: 100,
          },
          position: 1,
          initialValue: city.name,
          label: "City Name ",
        },
        state: {
          uiProps: {
            type: "select",
            options: usStates,
          },
          position: 2,
          initialValue: city.state,
          label: "State ",
        },
        regionId: {
          uiProps: {
            type: "select",
            options: regions,
          },
          position: 3,
          initialValue: city.regionId,
          label: "Region ",
          hoverHelp: () =>
            "Select the Region to which this City should be assigned. Cities may only be assigned to one Region.",
        },
        enabled: {
          uiProps: {
            type: "checkbox",
          },
          position: 4,
          initialValue: city.enabled,
          label: "Enabled ",
          hoverHelp: () =>
            "Uncheck this box to disable this City. This will hide the City throughout your OCS system.",
        },
      }}
      validation={formData => {
        if (!formData.name) return ERROR_EMPTY_NAME;
        if (formData.state === "-1") return ERROR_EMPTY_STATE;
        if (formData.regionId === "-1") return ERROR_EMPTY_REGION;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_NAME]: "Name can't be empty!",
        [ERROR_EMPTY_STATE]: "Pick a state!",
        [ERROR_EMPTY_REGION]: "Pick a region!",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/City.js